import { omitKeys } from '../utilities/omitKeys';
const dataSourceExcluded = [
    'data',
    'originalData',
    'info',
    'originalInfo',
    'meta',
    'metaInfo',
];
const rawDataExcluded = [
    'sourceSelector',
    'originalData',
    'originalInfo',
];
export function serializeNmriumState(nmriumState, options = {}) {
    const { version, data } = nmriumState;
    if (data.actionType)
        return nmriumState;
    const newNmriumState = {
        version,
    };
    const { includeData } = options;
    if (includeData !== 'noData') {
        newNmriumState.data = getNmriumData({ ...data }, includeData);
    }
    const { includeSettings, includeView } = options;
    if (includeSettings)
        newNmriumState.settings = nmriumState.settings;
    if (includeView)
        newNmriumState.view = nmriumState.view;
    return newNmriumState;
}
function getNmriumData(nmriumData, includeData) {
    const { spectra } = nmriumData;
    switch (includeData) {
        case 'dataSource':
            return getNmriumDataSource(nmriumData);
        case 'rawData':
            return {
                ...omitKeys(nmriumData, ['source']),
                spectra: spectra.map(getRawData),
            };
        default:
            return nmriumData;
    }
}
function getNmriumDataSource(nmriumData) {
    const { spectra } = nmriumData;
    if (!nmriumData.source) {
        throw new Error('source property should exists for dataSource serialization');
    }
    return {
        ...nmriumData,
        spectra: spectra.map(getDataSource),
    };
}
function getDataSource(spectrum) {
    return omitKeys(spectrum, dataSourceExcluded);
}
function getRawData(spectrumObject) {
    const { data, info, originalData, originalInfo } = spectrumObject;
    const spectrum = omitKeys(spectrumObject, rawDataExcluded);
    spectrum.data = originalData || data;
    spectrum.info = originalInfo || info;
    return spectrum;
}
//# sourceMappingURL=serializeNmriumState.js.map